import local_storage_keys from "constants/LocalStorage.constants";
import { DOMAIN_LINKING_LOCAL_STORAGE_KEYS } from "features/Integration/modules/DomainLinking/constants/DomainLinking.constants";

export const LOCAL_STORAGE_KEYS = {
  NEXT_STEPS: "next_steps",
  UUID: "uuid",
  BD_LOGIN: "bdLogin",
  IS_STAFF: "is_staff",
  BD_EMAIL: "bdEmail",
  ACCESS_TOKEN: "access_token",
  STAFF_TYPE: "staff_type", // from token api to check user is org staff member or main user
  REFRESH_TOKEN: "refresh_token",
  TOKEN_UUID: "token_uuid",
  CREATOR_USERNAME: "creator_username",
  ORG_UUID: "org_uuid",
  IS_FEATURE_ONBOARDED: local_storage_keys.IS_FEATURE_ONBOARDED,
  DEMO_LISTING_LINK: "demo_listing_link",
  FCM_TOKEN: "fcm_token",
  USER_IDENTITY: "user_identity",
  HIDE_INBOX_LEARN_MORE: "hide_inbox_learn_more", // this key is used to store boolean for whether to hide learn more in inbox or not
  ...DOMAIN_LINKING_LOCAL_STORAGE_KEYS,
};
